// extracted by mini-css-extract-plugin
export var bottomRightDock = "_19-0";